import {action, makeObservable, observable} from 'mobx';
import TableInterface from 'app/interfaces/poker/TableInterface';
import PlayerInterface from 'app/interfaces/poker/PlayerInterface';
import Get from 'app/utils/Get';
import {updateOrAddObject, deleteObjectById} from 'app/utils/updateArraysObject';
import {TableModel} from 'app/store/poker/TableModel';

export const STATE_WAIT = 'wait';
export const STATE_SIT_IN = 'sit_in';
export const STATE_BUY_IN = 'buy_in';

interface UpdatePlayerParamsInterface {
    table_id: string
    player: PlayerInterface
}

export interface StateParamsInterface {
    position?: number
}

export interface WinnerInterface {
    winner_index: number
    best_hand: string[]
}

export class PokerStore {
    @observable tables: TableInterface[] = [];

    @observable currentTables = new Map<string, TableModel>();

    @observable isDisabled = false;

    constructor() {
        makeObservable(this);
    }

    @action
    updatePokerState(state: boolean): void {
        this.isDisabled = state;
    }

    @action
    setTables = (tables: TableInterface[]): void => {
        this.tables = tables;
    };

    updatePlayer = (payload: UpdatePlayerParamsInterface): void => {
        const table = this.getTable(payload.table_id);

        if (table) {
            table.updatePlayer(payload.player);
        }
    };

    @action
    updateElementCollection(item: TableInterface): void {
        updateOrAddObject(this, 'tables', item);
    }

    @action
    deleteTable(id: number, table_id: string): void {
        deleteObjectById(this, 'tables', id);

        const table = this.currentTables.get(table_id);

        if (table) {
            table.currentTable.is_shutdown = true;
        }
    }

    @action
    closeTable(table_id: string): void {
        this.currentTables.delete(table_id);
    }

    @action
    openTable(table: TableInterface): void {
        if (this.currentTables.has(table.table_id)) {
            return;
        }

        this.currentTables.set(table.table_id, new TableModel(table));
    }

    getTable(table_id: string): TableModel {
        return this.currentTables.get(table_id);
    }

    loadTable = (table_id: string): void => {
        new Get({
            url: `/poker/tables/${table_id}`
        }).execute()
            .then(response => response.json())
            .then(response => {
                this.openTable(response);
            });
    };

    loadTables = (): void => {
        new Get({
            url: '/poker/tables'
        }).execute()
            .then(response => response.json())
            .then(response => {
                this.setTables(response.tables);
                this.updatePokerState(response.state);
            });
    };
}
